export class MatchComparison {
  constructor(a, b, location_type) {
    this.a = a
    this.b = b
    this.location_type = location_type
  }

  ageComparison() {
    return (this.a.ages_coverage ? -100 : 0) +
      (this.a.hours_coverage ? -100 : 0) +
      (this.b.ages_coverage ? 100 : 0) +
      (this.b.hours_coverage ? 100 : 0)
  }

  availabilityComparison() {
    return (this.a.availability_coverage ? -75 : 0) +
      (this.b.availability_coverage ? 75 : 0)
  }

  distanceComparison() {
    if(this.location_type == 'commute') {
      return this.a.distance_from_route - this.b.distance_from_route
    } else {
      return this.a.distance_from_origin - this.b.distance_from_origin
    }
  }

  stateRatingComparison() {
    return ((this.a.data.state_rating && this.a.data.state_rating.score) ? (-10 * this.a.data.state_rating.score) : 0) +
      ((this.b.data.state_rating && this.b.data.state_rating.score) ? (10 * this.b.data.state_rating.score) : 0)
  }

  resolve() {
    return this.ageComparison() +
      this.availabilityComparison() +
      this.stateRatingComparison() +
      this.distanceComparison()
  }
}
